module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item"
  }, [_c('Row', _vm._l((_vm.goods), function(item, index) {
    return _c('i-col', {
      key: index,
      staticStyle: {
        "padding": "20px 0 20px 0"
      },
      attrs: {
        "span": 24
      }
    }, [_c('i-col', {
      staticClass: "product-img",
      attrs: {
        "md": 10,
        "sm": 24,
        "xs": 24
      }
    }, [_c('img', {
      attrs: {
        "src": item.goods_img,
        "alt": "",
        "width": "100%"
      }
    })]), _vm._v(" "), _c('i-col', {
      staticClass: "product-desc",
      staticStyle: {
        "padding-left": "24px"
      },
      attrs: {
        "md": 14,
        "sm": 24,
        "xs": 24
      }
    }, [_c('h3', [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('p', {
      staticClass: "product-desc-item"
    }, [_vm._v(_vm._s(item.goods_remark) + " ")]), _vm._v(" "), _c('p', {
      staticClass: "product-desc-item"
    }, [(item.store_count > 0) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.buyNow(item.goods_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('buy_now')))]) : _c('button', {
      staticClass: "btn btn-gray btn-sm"
    }, [_vm._v(_vm._s(_vm.$t('store_mainpage_out_of_stock')))])])])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8153ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/Common/ProductItem.vue
// module id = 832
// module chunks = 0